import React from 'react';
import { Link } from 'react-router-dom';
import { MapPin, Phone, Mail, Clock } from 'lucide-react';
import LogoImage from './LogoImage';
import { firmInfo } from '../mockData';

const Footer = () => {
  return (
    <footer
      style={{
        background: 'var(--bg-darker)',
        color: 'white',
        padding: '4rem 0 2rem'
      }}
    >
      <div className="container">
        <div
          style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
            gap: '3rem',
            marginBottom: '3rem'
          }}
        >
          {/* Firm Info */}
          <div>
            <LogoImage height="60px" forFooter={true} />
            <p style={{ fontSize: '0.875rem', lineHeight: '1.6', color: 'rgba(245, 239, 231, 0.9)', marginTop: '1rem' }}>
              {firmInfo.description}
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 style={{ fontSize: '1.125rem', fontWeight: '600', marginBottom: '1.5rem', color: 'var(--accent-gold-light)' }}>
              Quick Links
            </h3>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '0.75rem' }}>
              <Link
                to="/"
                style={{
                  color: 'rgba(245, 239, 231, 0.9)',
                  textDecoration: 'none',
                  fontSize: '0.875rem',
                  transition: 'color 0.2s ease'
                }}
                onMouseEnter={(e) => (e.target.style.color = 'var(--accent-gold-light)')}
                onMouseLeave={(e) => (e.target.style.color = 'rgba(245, 239, 231, 0.9)')}
              >
                Home
              </Link>
              <Link
                to="/contact"
                style={{
                  color: 'rgba(245, 239, 231, 0.9)',
                  textDecoration: 'none',
                  fontSize: '0.875rem',
                  transition: 'color 0.2s ease'
                }}
                onMouseEnter={(e) => (e.target.style.color = 'var(--accent-gold-light)')}
                onMouseLeave={(e) => (e.target.style.color = 'rgba(245, 239, 231, 0.9)')}
              >
                Contact Us
              </Link>
              <a
                href="https://forms.gle/oEHDTk1DE5tVRCt8A"
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  color: 'rgba(245, 239, 231, 0.9)',
                  textDecoration: 'none',
                  fontSize: '0.875rem',
                  transition: 'color 0.2s ease'
                }}
                onMouseEnter={(e) => (e.target.style.color = 'var(--accent-gold-light)')}
                onMouseLeave={(e) => (e.target.style.color = 'rgba(245, 239, 231, 0.9)')}
              >
                Careers
              </a>
              <a
                href="https://forms.gle/1HMiCaaVV3uREu8XA"
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  color: 'rgba(245, 239, 231, 0.9)',
                  textDecoration: 'none',
                  fontSize: '0.875rem',
                  transition: 'color 0.2s ease'
                }}
                onMouseEnter={(e) => (e.target.style.color = 'var(--accent-gold-light)')}
                onMouseLeave={(e) => (e.target.style.color = 'rgba(245, 239, 231, 0.9)')}
              >
                Internships
              </a>
            </div>
          </div>

          {/* Contact Info */}
          <div>
            <h3 style={{ fontSize: '1.125rem', fontWeight: '600', marginBottom: '1.5rem', color: 'var(--accent-gold-light)' }}>
              Contact Information
            </h3>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
              <div style={{ display: 'flex', gap: '0.75rem', alignItems: 'flex-start' }}>
                <MapPin size={18} style={{ marginTop: '0.25rem', flexShrink: 0, color: 'var(--accent-gold-light)' }} />
                <span style={{ fontSize: '0.875rem', lineHeight: '1.5', color: 'rgba(245, 239, 231, 0.9)' }}>{firmInfo.address}</span>
              </div>
              <div style={{ display: 'flex', gap: '0.75rem', alignItems: 'center' }}>
                <Phone size={18} style={{ flexShrink: 0, color: 'var(--accent-gold-light)' }} />
                <a
                  href={`tel:${firmInfo.phone}`}
                  style={{ color: 'rgba(245, 239, 231, 0.9)', textDecoration: 'none', fontSize: '0.875rem', transition: 'color 0.2s ease' }}
                  onMouseEnter={(e) => (e.target.style.color = 'var(--accent-gold-light)')}
                  onMouseLeave={(e) => (e.target.style.color = 'rgba(245, 239, 231, 0.9)')}
                >
                  {firmInfo.phone}
                </a>
              </div>
              <div style={{ display: 'flex', gap: '0.75rem', alignItems: 'center' }}>
                <Mail size={18} style={{ flexShrink: 0, color: 'var(--accent-gold-light)' }} />
                <a
                  href={`mailto:${firmInfo.email}`}
                  style={{ color: 'rgba(245, 239, 231, 0.9)', textDecoration: 'none', fontSize: '0.875rem', transition: 'color 0.2s ease' }}
                  onMouseEnter={(e) => (e.target.style.color = 'var(--accent-gold-light)')}
                  onMouseLeave={(e) => (e.target.style.color = 'rgba(245, 239, 231, 0.9)')}
                >
                  {firmInfo.email}
                </a>
              </div>
              <div style={{ display: 'flex', gap: '0.75rem', alignItems: 'flex-start' }}>
                <Clock size={18} style={{ marginTop: '0.25rem', flexShrink: 0, color: 'var(--accent-gold-light)' }} />
                <span style={{ fontSize: '0.875rem', lineHeight: '1.5', color: 'rgba(245, 239, 231, 0.9)' }}>{firmInfo.hours}</span>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div
          style={{
            borderTop: '1px solid rgba(212, 175, 55, 0.3)',
            paddingTop: '2rem',
            marginTop: '2rem',
            textAlign: 'center'
          }}
        >
          <p style={{ fontSize: '0.875rem', color: 'rgba(245, 239, 231, 0.8)' }}>
            © {new Date().getFullYear()} {firmInfo.name}. All rights reserved.
          </p>
          <p style={{ fontSize: '0.75rem', color: 'rgba(245, 239, 231, 0.6)', marginTop: '0.5rem' }}>
            Professional Legal Services | Bengaluru, Karnataka
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;